import React from "react";
import { useSelector } from "react-redux";
import "./timesheet-detail-revamp.css";
import TimesheetParticipantSelect from "./TimesheetParticipantSelect";
import { getParticipantLabel } from "Constants/constant";
import { getSpRosteringSetting, getSpSetting } from "store/selector/sp.selector";
import TimesheetFilterDateRange from "./TimesheetFilterDateRange";
import TimesheetStatusChips from "./TimesheetStatusChips";
import TimesheetStatusSelect from "./TimesheetStatusSelect";
import TimesheetFilterField from "./TimesheetFilterField";

/** Figma chip order: All → Pending → Approved → In progress → Expired → Rejected */
const FIGMA_STATUS_ORDER = [
  "all",
  "pending",
  "approved",
  "In-progress",
  "Expired",
  "rejected",
];

const orderStatusOptions = (options) => {
  const rank = new Map(FIGMA_STATUS_ORDER.map((v, i) => [v, i]));
  return [...options].sort(
    (a, b) => (rank.get(a.value) ?? 99) - (rank.get(b.value) ?? 99)
  );
};

/**
 * Mobile + tablet: stacked controls + status dropdown.
 * lg+: single row — participant, date, divider, inline status chips.
 */
const TimesheetFilterBar = ({
  participants,
  selectedParticipants,
  onParticipantChange,
  fromDate,
  toDate,
  onDateRangeChange,
  setCheckboxes,
  isAllreadySelectedTimesheet,
  setSelectedFromDate,
  maxDate,
  setPage,
  statusOptions,
  selectedStatusValue,
  onStatusChange,
}) => {
  const spRosteringSetting = useSelector(getSpRosteringSetting);
  const spSetting = useSelector(getSpSetting);
  const careSector = spRosteringSetting?.care_sector ?? spSetting?.care_sector;
  const participantLabel = getParticipantLabel(careSector, false);
  const orderedStatusOptions = orderStatusOptions(statusOptions);

  return (
    <section className="timesheet-filter-bar rounded-2xl border border-[#E5E7EB] bg-white px-3 py-3 sm:px-3.5">
      <div className="flex flex-col gap-3 md:flex-row md:items-start md:gap-2.5">
        <TimesheetFilterField label={participantLabel} className="w-full shrink-0 md:w-auto">
          <TimesheetParticipantSelect
            options={participants}
            selectedOptions={selectedParticipants}
            onChange={onParticipantChange}
          />
        </TimesheetFilterField>

        <TimesheetFilterField label="Date range" className="w-full shrink-0 md:w-auto">
          <TimesheetFilterDateRange
            fromDate={fromDate}
            toDate={toDate}
            handleChange={onDateRangeChange}
            setCheckboxes={setCheckboxes}
            isAllreadySelectedTimesheet={isAllreadySelectedTimesheet}
            setSelectedFromDate={setSelectedFromDate}
            maxDate={maxDate}
            setPage={setPage}
          />
        </TimesheetFilterField>

        <TimesheetFilterField label="Status" className="w-full lg:hidden">
          <TimesheetStatusSelect
            options={orderedStatusOptions}
            selectedValue={selectedStatusValue}
            onChange={onStatusChange}
          />
        </TimesheetFilterField>

        <div
          className="hidden h-[34px] w-px shrink-0 bg-[#E5E7EB] lg:mt-[14px] lg:block"
          aria-hidden
        />

        <TimesheetFilterField
          label="Status"
          className="hidden min-w-0 flex-1 lg:flex"
        >
          <TimesheetStatusChips
            options={orderedStatusOptions}
            selectedValue={selectedStatusValue}
            onChange={onStatusChange}
          />
        </TimesheetFilterField>
      </div>
    </section>
  );
};

export default TimesheetFilterBar;
